import React, { Component } from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';

const CHUNK_RELOAD_KEY = 'async_chunk_reload_attempted';

function isChunkLoadError(error) {
  const message = error && error.message ? error.message : '';
  const name = error && error.name ? error.name : '';
  return (
    name === 'ChunkLoadError' ||
    message.indexOf('Loading chunk') !== -1 ||
    message.indexOf('ChunkLoadError') !== -1
  );
}

export default function asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
        loadError: null
      };
      Nprogress.configure({ showSpinner: false });
      Nprogress.start();
    }
    
    componentWillUnmount() {
      this.mounted = false;
    }
    async componentDidMount() {
      this.mounted = true;
      try {
        const { default: Component } = await importComponent();
        try { window.sessionStorage.removeItem(CHUNK_RELOAD_KEY); } catch (_) {}
        Nprogress.done();
        if (this.mounted) {
          this.setState({
            component: <Component {...this.props} />,
            loadError: null
          });
        }
      } catch (error) {
        Nprogress.done();
        if (isChunkLoadError(error)) {
          try {
            const alreadyReloaded = window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === 'true';
            if (!alreadyReloaded) {
              window.sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
              window.location.reload();
              return;
            }
          } catch (_) {}
        }
        if (this.mounted) {
          this.setState({ loadError: error });
        }
      }
    }

    render() {
      if (this.state.loadError) {
        return (
          <div style={{ padding: 24, textAlign: 'center' }}>
            <p style={{ marginBottom: 12 }}>Unable to load this page. Please reload and try again.</p>
            <button type="button" onClick={() => window.location.reload()}>
              Reload page
            </button>
          </div>
        );
      }
      const Component = this.state.component || <div />;
      return (
        <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
          {Component}
        </ReactPlaceholder>
      );
    }
  }
  return AsyncFunc;
}
